var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSquareDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#232323",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M1 15v6h20v-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 0v15"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M5 9l6 6 6-6"
  }))));
}

export default SvgIconSquareDownload;